import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Corporate } from '../../models/corporate';
import { CorporateService } from '../../services/corporate.service';

@Component({
  selector: 'app-corporates-admin-table',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule, MatButtonModule, MatFormFieldModule, MatInputModule],
  templateUrl: './corporates-admin-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./corporates-admin-table.component.css']
})
export class CorporatesAdminTableComponent {
  @Input() dataCorporate: Corporate[] = [];

  @Output() create = new EventEmitter<Corporate>();
  @Output() update = new EventEmitter<Corporate>();

  corporateForm!: FormGroup;
  mode: 'add' | 'edit' = 'add';
  editingIndex: number | null = null;
  showForm = false;

  constructor(private fb: FormBuilder, private corporateService: CorporateService) {}

  ngOnInit(): void {
    this.corporateForm = this.fb.group({
      name_corporate: ['', [Validators.required, Validators.maxLength(100)]],
      name_user: ['', [Validators.required, Validators.maxLength(50)]],
      last_name_user: ['', [Validators.required, Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  trackById(index: number, item: Corporate) {
    return item?.id ?? index;
  }

  startAdd() {
    this.mode = 'add';
    this.editingIndex = null;
    this.corporateForm.reset();
    this.showForm = true;
  }

  getUseersCorporates(c: Corporate, index: number) {
    
  }

  cancel() {
    this.showForm = false;
    this.corporateForm.reset();
  }

  save() {
    
    if (this.corporateForm.invalid) return;

    const formValue = this.corporateForm.value;
    const payload = {
      corporateName: formValue.name_corporate,
      email: formValue.email,
      name: formValue.name_user,
      familyName: formValue.last_name_user
    };

    this.corporateService.setCorporates(payload).subscribe({
      next: (response) => {
        
        const value: Corporate = {
          id: (response as any).id,
          name: (response as any).name
        };
        this.dataCorporate = [...this.dataCorporate, value];
        this.create.emit(value);
        this.showForm = false;
        this.corporateForm.reset();
      },
      error: (error) => {
        console.error('Error creating corporate:', error);
        // Manejar error, quizás mostrar mensaje
      }
    });
  }
}
